/* eslint no-param-reassign: 0 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAllForms,
  getAllDrafts,
  getAllDispatches,
} from 'apps/web_forms/api/api';
import { FormTypes } from 'apps/web_forms/utils/constants';

export const fetchFormList = createAsyncThunk(
  'app/fetchFormList',
  async (formId) => {
    const allForms = await getAllForms();

    const forms = allForms.filter((form) => form.type === FormTypes.FORM);

    if (formId) {
      return forms.filter((form) => form.identifier === formId);
    }

    return forms;
  }
);

export const fetchDispatchList = createAsyncThunk(
  'app/dispatchList',
  async (dispatchId) => {
    const allForms = await getAllDispatches();

    // Take dispatches
    const dispatches = allForms.filter(
      (form) => form.type === FormTypes.DISPATCH
    );

    if (dispatchId) {
      return dispatches.filter((form) => form.identifier === dispatchId);
    }

    return dispatches;
  }
);

export const fetchDraftList = createAsyncThunk(
  'app/fetchDraftList',
  async () => {
    const allDrafts = await getAllDrafts();
    return allDrafts;
  }
);

const initialState = {
  formList: { loading: true, data: [] },
  dispatchList: { loading: true, data: [] },
  draftList: { loading: true, data: [] },
  showingActionSuccessMessage: false,
  theSuccessfulAction: 'submitted',
  selectedForm: {},
  modal: { type: null, extraProps: {} },
  notification: {text: null, type: null,}
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    resetAppSliceState: () => initialState,
    setSelectedForm(state, action) {
      state.selectedForm = action.payload;
    },
    resetSelectedForm(state, _) {
      state.selectedForm = initialState.selectedForm;
    },
    showActionSuccessMessage(state, action) {
      state.showingActionSuccessMessage = action.payload;
    },
    setSuccessfulAction(state, action) {
      state.theSuccessfulAction = action.payload;
    },
    setModal(state, action) {
      state.modal = action.payload;
    },
    resetModal(state) {
      state.modal = initialState.modal;
    },
    setNotification(state, action) {
      state.notification = action.payload;
    },
    resetNotification(state) {
      state.notification = initialState.notification;
    },
  },
  extraReducers: {
    [fetchFormList.pending]: (state) => {
      state.formList = { loading: true };
    },
    [fetchFormList.fulfilled]: (state, action) => {
      state.formList = { loading: false, data: action.payload };
    },
    [fetchFormList.rejected]: (state, action) => {
      state.formList = { loading: false, error: action.error };
    },
    [fetchDispatchList.pending]: (state) => {
      state.dispatchList = { loading: true };
    },
    [fetchDispatchList.fulfilled]: (state, action) => {
      state.dispatchList = { loading: false, data: action.payload };
    },
    [fetchDispatchList.rejected]: (state, action) => {
      state.dispatchList = { loading: false, error: action.error };
    },
    [fetchDraftList.pending]: (state) => {
      state.draftList = { loading: true };
    },
    [fetchDraftList.fulfilled]: (state, action) => {
      state.draftList = { loading: false, data: action.payload };
    },
    [fetchDraftList.rejected]: (state, action) => {
      state.draftList = { loading: false, error: action.error };
    },
  },
});

export const {
  resetAppSliceState,
  showActionSuccessMessage,
  setSuccessfulAction,
  setSelectedForm,
  setModal,
  resetModal,
  resetNotification,
  setNotification,
  resetSelectedForm,
} = appSlice.actions;
export default appSlice.reducer;
